import { render, staticRenderFns } from "./Bundle.vue?vue&type=template&id=05fc9b34&scoped=true&"
import script from "./Bundle.vue?vue&type=script&lang=js&"
export * from "./Bundle.vue?vue&type=script&lang=js&"
import style0 from "./Bundle.vue?vue&type=style&index=0&id=05fc9b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc9b34",
  null
  
)

export default component.exports